export default __webpack_public_path__ + "static/media/image4.d32beac6.png";